import { render, staticRenderFns } from "./chWriterInfo.vue?vue&type=template&id=23bc00ef&scoped=true&"
import script from "./chWriterInfo.vue?vue&type=script&lang=js&"
export * from "./chWriterInfo.vue?vue&type=script&lang=js&"
import style0 from "./chWriterInfo.vue?vue&type=style&index=0&id=23bc00ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc00ef",
  null
  
)

export default component.exports